import axios from 'axios';
import jsontoxml from 'jsonxml'

import Fishbowl from './fishbowl.js';
import Fishion from './fishion.js';

const BASE_API = process.env.VUE_API_ROOT;
let ORDER_PREFIX = 'TP';
let PREFIX_SEPARATOR = ORDER_PREFIX.substr(-1);
let ERROR_MSG = '';

let ops_email = 'ops@andymark.com'
let dept_dict = {
  'AndyMark Development': 'engineeringdirector',
  'AndyMark Operations': 'operationsdirector',
  'AndyMark Marketing': 'marketingdirector',
  'AndyMark Machine Shop': 'machineshopmanager',
  'AndyMark IT': 'technologydirector',
  'CyberTooth Robotics Team': 'cybertoothcontact',
  'AndyMark Event Parts': 'operationsdirector' // ???
};

export default {
  esc( str ){
    return (''+str).replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/'/g, '&apos;')
      .replace(/"/g, '&quot;')
      .replace(/[^\x09\x0A\x0D\x20-\xFF\x85\xA0-\uD7FF\uE000-\uFDCF\uFDE0-\uFFFD]/gm, '');
  },
  getError() {
    return ERROR_MSG;
  },
  getProductRequestString( parts ) {
    var items = '';
    parts.map((x) => {
      items += `${x.qty}x ${x.num}\n`;
      return x;
    })
    return items;
  },
  async getOrderNumber() {
    var orderNum = ''
    return Fishbowl.getHouseOrderNumber(ORDER_PREFIX)
    .then((data) => {
      if (data.waitSubmit) {
        return 'wait';
      }
      var split_order = data[0].num.split(PREFIX_SEPARATOR);
      var num = parseInt(split_order[split_order.length - 1], 10) + 1;
      num += '';
      while (num.length < 5) num = '0' + num;
      orderNum = ORDER_PREFIX + num;
      return orderNum;
    })
    .catch((e) => {
      console.error(e);
      ERROR_MSG = e;
      return 'error';
    });
  },
  async addSO( orderData, orderNum ) {
    return axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/champ/add-inventory-request/${orderNum}`,
      data: orderData,
    }).then( (response) => {
      return response.data;
    }).catch((error) => {
      this.resetOrderNumFlag();
      console.error(error);
      ERROR_MSG = error;
      return -1;
    });
  },
  async commitPick( orderNum ) {
    return axios({
      method: 'post',
      header: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/champ/pick-add/${orderNum}`
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error(error);
        ERROR_MSG = error;
        return -1;
      });
  },
  async getChampStatus(uuid, count = 0) {
    return axios.get(`${BASE_API}/champ/request-status/${uuid}`)
    .then((response) => {
      if (response.data && response.data.Processed) {
        if (response.data.ErrorCode != 1000) {
          //Some known error occured on CHAMP's side
          ERROR_MSG = response.data.Response;
          return -1;
        }
        else {
          //Response indicated success
          return 0;
        }
      }
      else if (count >= 20) {
        //Request took too long
        return -2;
      }
      else {
        //Still awaiting a response
        return 10;
      }
    })
    .catch((error) => {
      RequestService.resetOrderNumFlag();
      console.error(error);
      ERROR_MSG = error;
      return -3;
    })
  },
  emailUsers( googleUser, notes, orderNum, extraParts, pickCommitted ) {
    let emails = [];
    emails.push(googleUser.emails.value)
    emails.push(ops_email)
    emails.push(dept_dict[notes.user_department] + '@andymark.com')
    emails.push('thesystem@andymark.com')

    axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/notify/${emails}`,
      data: {
        ordernum: orderNum,
        submitter: googleUser.names.displayNameLastFirst,
        urgency: notes.urgency,
        returnFlag: notes.returnFlag,
        notes: notes.text,
        project: notes.project,
        pickCommitted: pickCommitted,
        hasNonProducts: extraParts.length > 0,
        nonProducts: this.getProductRequestString(extraParts),
      },
    });
  },
  emailSoloRequest( googleUser, extraParts, notes ) {
    let emails = [];
    emails.push(googleUser.emails.value)
    emails.push(ops_email)
    if (typeof(dept_dict[notes.user_department]) !== 'undefined') {
      emails.push(dept_dict[notes.user_department] + '@andymark.com')
    }

    axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/notify/nonproducts-only/${emails}`,
      data: {
        submitter: googleUser.names.displayNameLastFirst,
        nonProducts: this.getProductRequestString(extraParts),
      },
    });
  },
  resetOrderNumFlag() {
    axios.get(`${BASE_API}/reset-order-num-flag`)
  },
}



// WEBPACK FOOTER //
// /src/services/requestorder.js